import { Button, ButtonGroup, Grid, Link, Typography } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';

import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import { TableSortLabel } from '@material-ui/core';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import http from "../services/httpService";
import staticFiles from '../services/staticApi';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { getDateTime, investmentDetailsPath, subscriptionManagerPath, searchFilter,handleSort } from "../utils/varialbles";
import {
    IconFlagCA, IconFlagIN, IconFlagUS
} from 'material-ui-flags';
import SearchBar from "material-ui-search-bar";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

const getFlags = (country) => {
    let CountryMapper = {
        "INR": IconFlagIN,
        "USD": IconFlagUS,
        "CAD": IconFlagCA
    }
    if (country && CountryMapper[country]) {
        return React.createElement(CountryMapper[country]);

    } else {
        return React.createElement(CountryMapper["India"]);
    }
}

const getCurrency = (name) => {
    let currencyMapper = {
        "INR": "₹",
        "USD": "$",
        "CAD": "C$"
    }
    if (name && currencyMapper[name]) {
        return currencyMapper[name];

    } else {
        return currencyMapper["INR"];
    }
}
const useStyles = makeStyles({
    root: {
        width: '100%',
    }
});
const columns = [
    // { label: 'Name', id: 'type', minWidth: 150 },
    { label: 'Type', id: 'Type', minWidth: 200 },
    { label: 'Subject', id: 'Subject', minWidth: 200 },
    { label: 'Body', id: 'Body', minWidth: 200 },
    { label: 'Date and Time', id: 'Created_at', minWidth: 200, format: "Date" },


];
function InvestorNotifiCationManager() {
    const classes = useStyles();
    const history = useHistory();
    const [publishedActive, setPublishedActive] = useState(false);
    const [archivedActive, setArchivedActive] = useState(true);
    const location = useLocation();
    const myparam = location.state;
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [rows, setRows] = React.useState([]);
    const [searched, setSearched] = React.useState("");
    const [orignalRows, setOriginalRows] = React.useState([]);
    const [orderBy, setOrderBy] = React.useState("cust__createddt");
    const [order, setOrder] = React.useState("asc");
    const requestSearch = (searchedVal) => {
        let rowsTemp = [...orignalRows];

        setPage(0);
        setRows(searchFilter(searchedVal, rowsTemp));

    };

    const cancelSearch = () => {
        setSearched("");
        requestSearch(searched);
    };;
    const [overview, setOverview] = React.useState({});
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
 const handleRequestSort = (e,property, format) => {
        let isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        let tempRows=[...rows]
        let finalRows=handleSort(property,format,tempRows,isAsc)
        
        setRows(finalRows);
        setPage(0);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const viewInvestmentDetails = (object) => {
        history.push({
            "pathname": investmentDetailsPath, state: myparam
        });
    }
    useEffect(() => {
        if (myparam && myparam.customer_id) {
            http.get("/notification_history/" + myparam.customer_id).then((response) => {
                if (response && response.data && response.data.Notifications && Array.isArray(response.data.Notifications) && response.data.Notifications.length > 0) {
                    setOriginalRows(response.data.Notifications);
                    setRows(response.data.Notifications)
                }

            }).catch((error) => {
            })
        } else {
            history.goBack()
        }
    }, []);
    const makeActive = (event) => {
        if (event === "overview") {
            if (myparam && myparam.customer_id) {
                history.push({
                    "pathname": subscriptionManagerPath, state: myparam
                });
            }
        }

    }
    return (
        <div className={classes.root}>
            <AppBar position="static" style={{ marginBottom: 5, paddingTop: 3, paddingBottom: 3 }}>
                <Grid container component="main">
                    <Grid item xs={6} sm={6} md={6}>
                        <ButtonGroup>
                            <Button variant={"contained"} color="primary" style={{ marginLeft: 10, borderRadius: 60 }} onClick={viewInvestmentDetails} name="invOverView">OverView</Button>
                            {/* <Button variant={archivedActive ? "contained" : "outlined"} color="primary" style={{ marginLeft: 10, borderRadius: 60 }} onClick={() => makeActive("portfolio")} name="archivedPostsButton">Portfolio</Button> */}
                        </ButtonGroup>

                    </Grid>


                </Grid>

            </AppBar>
            <Grid container style={{ marginTop: "10px" }}>
            <Grid item xs={12} sm={5} md={5} >
                <Button variant="outlined" color="default" startIcon={<ArrowBackIosIcon />} onClick={viewInvestmentDetails}>Back</Button>
            </Grid>
                <Grid item xs={12} sm={6} >
                    <Typography  variant="h6">
                    Notification History
                    </Typography>
                </Grid>
                </Grid>
            <Paper className={classes.root}>
                <SearchBar
                    value={searched}
                    onChange={(searchVal) => requestSearch(searchVal)}
                    onCancelSearch={() => cancelSearch()}
                    className={"mt30"}
                />
                <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 25, 50, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table" size="small">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id + column.label.trim()}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        <TableSortLabel
                                    active={orderBy === column.id}
                                    direction={orderBy === column.id ? order : 'asc'}
                                    onClick={e => handleRequestSort(e, column.id, column.format)}
                                >
                                        {column.label}
</TableSortLabel>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={index + "a"}>
                                        {columns.map((column, index) => {
                                            const value = row[column.id];
                                            return (
                                                <TableCell key={index + column.id + column.label.trim()} align={column.align}>
                                                    {column.format && typeof value === 'number' ?
                                                        column.format(value) : (column.id === "detailsButton") ?
                                                            (<Button variant="contained" color="primary" style={{ borderRadius: 20 }} onClick={() => viewInvestmentDetails(row)}>
                                                                View Details
                                                            </Button>
                                                            ) :
                                                            (column.format === "Date") ? getDateTime(value) :
                                                                (column.format === "boolean" && row[column.id]) ? "Yes" :
                                                                    (column.format === "boolean" && !row[column.id]) ? "No" :
                                                                        (column.format === "link" && value && value !== "") ? <Link variant="body2" href={staticFiles + value} target='_blank'>{value}</Link> :
                                                                            (column.format === "currency" && value) ? <><IconButton>{getFlags(row["currency"])}</IconButton>{getCurrency(row.currency) + " " + value}</> : value
                                                    }
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>

            </Paper>
        </div>
    )


}

export default InvestorNotifiCationManager;
